import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomerRef } from '../../services/types';

interface PartCustomerRefsTableProps {
  customerRefs: CustomerRef[];
}

export const PartCustomerRefsTable: React.FC<PartCustomerRefsTableProps> = ({
  customerRefs,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded border border-gray-300 shadow-sm flex flex-col">
      {/* Header */}
      <div className="bg-indigo-50 px-4 py-3 border-b border-indigo-200 flex-shrink-0">
        <h3 className="text-lg font-bold text-indigo-900">
          {t('parts.customerReferences')}
        </h3>
        <p className="text-xs text-indigo-700">
          {customerRefs.length}{' '}
          {customerRefs.length === 1
            ? t('parts.records')
            : t('parts.recordPlural')}
        </p>
      </div>

      {/* Content */}
      {customerRefs.length > 0 ? (
        <div className="overflow-x-auto flex-grow">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-100 border-b border-gray-200 sticky top-0">
                <th className="px-4 py-3 text-left font-semibold text-gray-700">
                  {t('parts.customerRefsTable.customerReference')}
                </th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700">
                  {t('parts.customerRefsTable.descriptions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {customerRefs.map((record, idx) => (
                <tr key={idx} className="hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3 text-gray-900 font-medium">
                    {record.custPartNum}
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    <div className="flex flex-col gap-1">
                      {record.descriptionFR && (
                        <div className="font-medium">
                          {record.descriptionFR}
                        </div>
                      )}
                      {record.descriptionEN && (
                        <div className="text-sm text-gray-600">
                          {record.descriptionEN}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="pb-2">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-tight mb-1">
                {t('parts.customerRefsTable.customerReference')}
              </p>
              <p className="text-sm font-medium text-gray-900">-</p>
            </div>
            <div className="pb-2">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-tight mb-1">
                {t('parts.customerRefsTable.descriptions')}
              </p>
              <p className="text-sm font-medium text-gray-900">-</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
